import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { folderView } from "../../redux/actions/folderAction";
import Pagination from "../../components/pagination/pagination";
import { LuSearch } from "react-icons/lu";
import { availableLanguages } from "../../components/data/languageData";
import { documentsListAction } from "../../redux/actions/documentAction";
import { IoArrowBack } from "react-icons/io5";
import { getLangName } from "../../components/helper";
import { useAuth } from '../../context/AuthContext';

const ViewFolder = () => {
    const dispatch = useDispatch();
    const [folderData, setFolderData] = useState({});
    const { id } = useParams();

    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState([]);
    const [filterTerm, setFilterTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const { isAdmin, isTeamLead } = useAuth();
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');

    const handleSort = (column) => {
        const newSortOrder = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
        const sortedData = [...filteredData].sort((a, b) => {
            if (a[column] < b[column]) return newSortOrder === 'asc' ? -1 : 1;
            if (a[column] > b[column]) return newSortOrder === 'asc' ? 1 : -1;
            return 0;
        });
        setSortColumn(column);
        setSortOrder(newSortOrder);
        setFilteredData(sortedData);
    };

    const onViewSuccess = (data) => {
        setFolderData(data.data.data);
    };

    const onViewError = (data) => {
        errorToast(data.data.message);
    };

    useEffect(() => {
        if (id) {
            dispatch(folderView({ id }, onViewSuccess, onViewError));
        }
    }, [id, dispatch]);


    useEffect(() => {
        setLoading(true);
        dispatch(documentsListAction({ page, page_size: rowsPerPage, search: filterTerm, folder_id: id }, onSuccess, onError));
    }, [dispatch, filterTerm, page, rowsPerPage]);

    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setFilteredData(data?.data?.data?.documents);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const initialValues = {
        id: folderData?.id || "",
        name: folderData?.name || "",
    };


    return (
        <div className="d-flex vh-100 overflow-auto">
            <div className="w-100">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                    <span className="px-1 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">
                        View Folder
                    </h2>
                </div>
                <div className="flex-grow-1 pt-3">
                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="name" className="py-1 fw_600">
                                            Folder Name
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                type="text"
                                                placeholder="Enter Folder Name"
                                                id="name"
                                                name="name"
                                                className="input-field"
                                                disabled={true}
                                                style={{ width: "20rem" }}
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="name"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="text-start pt-3">
                    <label className="mx-4 fw_600">
                        Folder Documents
                    </label>
                    <div className="mt-2 mx-4 overflow-auto " >
                        <div className="input-group mb-3">
                            <span className="input-group-text gap-2">
                                <LuSearch />
                                Search
                            </span>
                            <input
                                type="text"
                                className="input-field w-75"
                                placeholder="Enter document name"
                                value={filterTerm}
                                onChange={(e) => setFilterTerm(e.target.value)}
                            />
                        </div>
                        <div className="table-responsive overflow-auto" style={{ minHeight: '30rem', minWidth: '100%' }}>
                            <table className="table table-bordered " >
                                <thead className="table-light">
                                    <tr className="text-start text-nowrap">

                                        <th width={'10%'} className='fw_400' onClick={() => handleSort('name')}>
                                            Document Name {sortColumn === 'name' && (sortOrder === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th width={'10%'} className='fw_400' onClick={() => handleSort('source_lang')}>
                                            Source Language {sortColumn === 'source_lang' && (sortOrder === 'asc' ? '↑' : '↓')}
                                        </th>
                                        {isTeamLead && (
                                            <th width={'10%'} className='fw_400' onClick={() => handleSort('targetLanguage')}>
                                                Target Language {sortColumn === 'targetLanguage' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                        )}

                                        <th width={'10%'} className='fw_400' onClick={() => handleSort('uploadBy')}>
                                            Upload By {sortColumn === 'uploadBy' && (sortOrder === 'asc' ? '↑' : '↓')}
                                        </th>
                                        {!isAdmin && (
                                            <th width={'10%'} className='fw_400' onClick={() => handleSort('assignedBy')}>
                                                Assigned By {sortColumn === 'assignedBy' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                        )}
                                        {isAdmin && (
                                            <th width={'10%'} className='fw_400' onClick={() => handleSort('assigned_teams')}>
                                                Assigned Team {sortColumn === 'assigned_teams' && (sortOrder === 'asc' ? '↑' : '↓')}
                                            </th>
                                        )}
                                        <th width={'14%'} className='fw_400' onClick={() => handleSort('status')}>
                                            Status {sortColumn === 'status' && (sortOrder === 'asc' ? '↑' : '↓')}
                                        </th>
                                        <th width={'14%'} className='fw_400'>
                                            Comments
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="6">
                                            </td>
                                        </tr>
                                    ) : filteredData?.length > 0 ? (
                                        filteredData?.map((item, index) => (
                                            <tr key={index} className='text-start'>

                                                <td>{item?.name}</td>
                                                <td>{getLangName(item?.source_lang)}</td>
                                                {isTeamLead && (
                                                    <>
                                                        <td>{item?.assignedTeam?.target_lang?.map((lang) => `${getLangName(lang)} (${lang})`).join(", ")}</td>
                                                    </>
                                                )}
                                                <td>{item?.uploadedUser?.email}</td>
                                                {!isAdmin && (
                                                    <td>
                                                        {item?.assignedTeam?.assignedBy?.email}
                                                    </td>
                                                )}
                                                {isAdmin && (
                                                    <td>
                                                        {item?.assignedTeams?.map((team) => team.team.name).join(', ')}
                                                    </td>
                                                )}
                                                <td>{item?.status}</td>
                                                <td >{item?.comments}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8">No rows to display</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {paginationData?.total > 10 && (
                            <div className="d-flex justify-content-end mx-3">
                                <Pagination
                                    data={paginationData}
                                    nextFunc={() => setPage(page + 1)}
                                    prevFunc={() => setPage(page - 1)}
                                    setPageRowFunc={(value) => {
                                        setPage(1);
                                        setRowsPerPage(value);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewFolder;
